//
// Internal global/config variables
//

// eslint-disable-next-line
__webpack_public_path__ = global.getDistURL("");

// BASE_URL and IS_BA_EDITOR set in ../init.js.
global.IMAGE_UPLOAD_URL = "https://beastacademy.com/";
global.PDF_URL =
	process.env.NODE_ENV === "production"
		? global.BASE_URL + "u/pdfs/"
		: "http://beastacademy.com/u/pdfs/";

// If we're inside baeditor's iframe, PLAY_PROBLEM_DATA will be set with the
// problem to preview.
global.PLAY_PROBLEM_DATA = global.PLAY_PROBLEM_DATA || null;

// If we've loaded the bundle in another page, like the CanvasMath playground,
// to grab dependencies, then this will be true. Disables rendering the Beast
// Academy site so the playground can do its own thing.
const isPlaygroundPage = global.IS_PLAYGROUND_PAGE || false;

const GlobalFlags = require("./util/GlobalFlags");
if (process.env.NODE_ENV === "production") {
	GlobalFlags.setProductionEnv();
} else {
	GlobalFlags.setDevelopmentEnv();
}

const DataDogRUM = require("./util/DataDogRUM");
DataDogRUM.init();

const Mixpanel = require("./util/Mixpanel");
Mixpanel.init();
Mixpanel.stopSessionRecordingIfSchoolUrl();

//
// console.error hijacking
//

const _ = require("lodash");
const ErrorUtil = require("../../shared/ErrorUtil");

// TODO: remove this once we've migrated logs
/* eslint-disable no-console */
if (global.console && global.console.error) {
	const orig = console.error;
	console.error = (...args) => {
		if (
			/ppxo_xc_ppbutton_error/.test(args[0]) ||
			/ppxo_unhandled_error/.test(args[0])
		) {
			//Skip logging the errors the paypal button throws when quickly switching pages.
			//Also skip another common paypal error that doesn't cause any issues.
			return;
		}

		const request = _.get(args, [1, "request"]);
		if (
			args[0] === "Unhandled promise rejection" &&
			/hotjar\.com/.test(request)
		) {
			return;
		}

		orig(...args);

		ErrorUtil.log("E_CONSOLE_ERROR", String(args[0]), {
			otherArgs: args.slice(1),
		});
		if (process.env.NODE_ENV !== "production") {
			orig.apply(console, args);
		}
	};
}
/* eslint-enable no-console */

//
// Polyfills and one-time initialization
//

// Most polyfills are now in dist/corejs.js, added directly to HTML.

// some es6 methods
require("./fakefill")();

// window.fetch polyfill
require("whatwg-fetch");

// context drawImage replacement.
const CanvasImage = require("./util/CanvasImage");
CanvasImage.improveShortvasDrawImage();

// Inject DiagramHelper dependencies into CanvasMath code. Needed for cyclic dependency issue.
const CanvasMath = require("./canvasmath/CanvasMath");
const diagramHelpers = require("./canvasmath/diagram/DiagramHelpers");
CanvasMath.injectDependencies(diagramHelpers);

// A weird React thing
const doReactFix = require("./ReactDOMFix");
doReactFix();

//
// Page startup
//

const {startReact} = require("./startReact");

// The waitForWebFonts global is in ../init.js.
global.waitForWebFonts(() => {
	// Extra methods on Shortvas contexts. Must be run after WebFont finishes.
	require("./CanvasMods")();
	if (process.env.NODE_ENV === "production" || !isPlaygroundPage) {
		startReact();
	}
});

//
// Playground page things
//

// If embedding in other pages, export some things as global variables
if (isPlaygroundPage) {
	const Shortvas = require("shortvas");

	// Used generally when this code is embedded.
	global.Shortvas = Shortvas;
	global.CanvasMath = CanvasMath;
	// This is used by the dev/canvasmath page.
	global.withImageLoading = CanvasImage.withLoading;

	// The remaining playground pages and baeditor should also import the
	// trainer bundle. The main file in that bundle sets the globals that are
	// needed.
	const Bundles = require("./Bundles");
	const LoadBundle = require("./loadBundle");
	Bundles.injectLoadBundle(LoadBundle);
	Bundles.load("trainer");
}

global.__BA_CORE_BUNDLE_DONE__ = true;
